import {Helmet} from 'react-helmet-async';
import {useTranslation} from 'react-i18next';
import '../../css/frontend/association-page.css';

export default function Association() {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>SpaceTime Community | Association</title>
                <meta name="description"
                      content="Σύλλογος Διεπιστημονικής Δημιουργίας Χωροχρόνος - Spacetime. Σκοπός, αποστολή και καταστατικό."/>
                <meta property="og:title" content="SpaceTime | Association"/>
                <meta property="og:url" content="https://spacetime.community/association"/>
            </Helmet>

            <div className="association-page">
                {/* Hero / Cover */}
                <header className="association-hero">
                    <img
                        src="/img/spacetime_logo_small.png"
                        alt="Spacetime Association cover"
                        className="association-cover"
                    />
                    <h1 className="association-title">Σύλλογος Διεπιστημονικής Δημιουργίας Χωροχρόνος</h1>
                </header>

                {/* Body */}
                <main className="association-body-container">
                    <section className="association-section association-with-image">
                        <div className="association-text">
                            <h2 className="section-heading">{t("Σκοπός")}</h2>
                            <img
                                src="/img/association/association-side-image.jpg"
                                alt="Association activity"
                                className="association-float-image"
                            />
                            <p>
                                {t("small_article_for_spacetime_p1")}
                            </p>
                            <p>
                                {t("small_article_for_spacetime_p2")}
                            </p>
                            <p>
                                {t("small_article_for_spacetime_p3")}
                            </p>
                            <p>
                                {t("small_article_for_spacetime_p4")}
                            </p>
                        </div>
                    </section>


                    {/* CTA bar */}
                    <section className="association-cta">
                        <a
                            href="/img/association/katastatiko_no_signs.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cta-button"
                            aria-label="Άνοιγμα Καταστατικού (PDF) σε νέο παράθυρο"
                        >
                            {t("articles_of_association")} (PDF)
                        </a>

                    </section>
                </main>
            </div>
        </>
    );
}
